import { upperFirst } from 'lodash'

import { components, proxy } from '@/utils'

import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy() ],

    methods: {
      watchValueHandler() {
        return
      },
      watchProxyHandler() {
        return
      }
    },

    render(h) {
      return h(
        settingsFields(options),
        {
          props: {
            value: this.proxy,
            items: [ { component: components.switch } ]
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
